<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
  <sc-flex-fitting-content [vertical]="true">
    <sc-tab-group #transportCreationProfilesTabGroup *ngIf="data.transportCreationProfileGroups.length > 1">
      <sc-tab *ngFor="let group of data.transportCreationProfileGroups, let i = index" [title]="group.displayName" [data]="group" [active]="i===0">
        <app-service-response [responseMessages]="data.responseMessages"></app-service-response>
        <sc-scroll-pane>
          <sc-flex [wrap]="true">
            <app-action-tablet-transport-creation-profile-details 
              (transportCreationProfileSelected)="createNewTransportWithVehicle(reference)"
              [transportCreationProfile]="reference" 
              *ngFor="let reference of group.transportCreationProfiles"></app-action-tablet-transport-creation-profile-details>
            </sc-flex>
        </sc-scroll-pane>
      </sc-tab>
    </sc-tab-group>
    <ng-container *ngIf="data.transportCreationProfileGroups.length === 1">
      <app-service-response [responseMessages]="data.responseMessages"></app-service-response>
      <sc-scroll-pane>
          <sc-flex [wrap]="true">
            <app-action-tablet-transport-creation-profile-details 
                  (transportCreationProfileSelected)="createNewTransportWithVehicle(reference)"
                  [transportCreationProfile]="reference"
                  *ngFor="let reference of data.transportCreationProfileGroups[0].transportCreationProfiles"></app-action-tablet-transport-creation-profile-details>
          </sc-flex>
      </sc-scroll-pane>
    </ng-container>
  </sc-flex-fitting-content>

    <sc-actionbar>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button (click)="cancel()"/>
    </sc-actionbar>

</sc-flex>
